import {
    AfterContentInit,
    ChangeDetectorRef,
    Component,
    ContentChild,
    HostBinding,
    Inject,
    Input,
    OnDestroy,
    OnInit, TemplateRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ImmutableRedux } from "../../../redux/immutable-redux.service";
import { NS_UIState } from "../../../types";
import { CommonListActionsDirective } from "../actions.directive";
import { PLAINLIST_STATE_PROP } from "../state-props";
import { commonPlainListReducerFactory } from "./reducer";

import { isEqual } from "lodash";

@Component({
    selector: "common-plain-list",
    templateUrl: "./common-plain-list.component.html",
})
export class CommonPlainListComponent implements OnInit, OnDestroy, AfterContentInit {
    @HostBinding("class") public classes = "u-flex-grow-1 u-display-block u-hex-width-full";

    @ContentChild(TemplateRef, {static: false}) public templateRef: TemplateRef<any>;
    @Input() public stateProp: string;
    @Input() public listType: "bullet" | "number" | "section" | "none" = "bullet";
    public detailId;
    @Input("detailId") public set detailIdInput(value: any) {
        this.detailId = value;
    }
    @Input() public detailField: any = "id";
    @Input() public initialState: NS_UIState.IGenericListState = {
        listData: {
            params: {},
            results: [],
            initWhenReady: false,
        },
    };

    public list$: Subscription;
    public results: any[] = [];
    public initialized = false;
    public isExhausted = true;

    constructor(
        private ngRedux: ImmutableRedux<any>,
        private cdf: ChangeDetectorRef,
        public listActions: CommonListActionsDirective,
        @Inject(PLAINLIST_STATE_PROP) public rootProp,
    ) {
        this.listActions.rootProp = this.rootProp;
    }

    public ngOnInit(): void {
        this.ngRedux.registerComponent(
            commonPlainListReducerFactory,
            this.rootProp,
            this.stateProp,
            this.initialState,
        );
    }

    public ngAfterContentInit(): void {
        this.list$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state: any) => {
            this.initialized = true;
            if (!!state && !isEqual(this.results, state.listData.results)) {
                this.results = state.listData.results;
                this.isExhausted = state.listData.isExhausted;
                this.cdf.markForCheck();
            }
        });
    }

    public ngOnDestroy() {
        if (!!this.list$) {
            this.list$.unsubscribe();
        }
    }
}
